import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import LayoutPage from "../Layout";
import axios from "axios";
import { toast } from "react-toastify";
import { useFormik } from "formik";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import styled from "styled-components";
import ThumbnailPreview from "./ThumbnailPreview";

function AddNews() {
  const [disabledSubmit, setDisabledSubmit] = useState(false);
  const [importingSubstack, setImportingSubstack] = useState(false);
  const [substackUrl, setSubstackUrl] = useState("");
  const [importedImageUrl, setImportedImageUrl] = useState("");
  const [importDetails, setImportDetails] = useState(null);
  const [contentData, setContentData] = useState("");
  const [image, setImage] = useState();
  const editor = useRef(null);
  const [initialValues, setInitialValues] = useState({
    topic: "",
    heading: "",
    content: "",
    description: "",
    newsImage: null,
    importedImageUrl: "",
  });
  const navigate = useNavigate();

  const validationSchema = Yup.object({
    topic: Yup.string()
      .max(10, "Topoic must be at most 10 character")
      .trim()
      .required("Topic is required"),
    heading: Yup.string()
      .max(500, "Heading must be at most 500 characters")
      .trim()
      .required("Heading is required"),
    // content: Yup.string().required("Content is required"),
    description: Yup.string()
      .max(2000, "Description must be at most 2,000 characters")
      .trim()
      .required("Description is required"),
    newsImage: Yup.mixed()
      .nullable()
      .test(
        "imageRequired",
        "Blog Image is required",
        function (value) {
          return Boolean(value || this.parent.importedImageUrl);
        }
      )
      .test(
        "fileType",
        "Only `.jpeg, .png, .jpg, .webp` files are allowed",
        (value) =>
          !value ||
          ["image/jpeg", "image/jpg", "image/png", "image/webp"].includes(
            value.type
          )
      ),
    importedImageUrl: Yup.string().nullable(),
    // .test(
    //   "imageDimensions",
    //   "Image dimensions must be at max 900px width and height minimum 400px",
    //   async (value) => {
    //     if (!value) return false;
    //     const file = value;

    //     const imageDimensions = new Promise((resolve, reject) => {
    //       const reader = new FileReader();
    //       reader.onload = (event) => {
    //         const img = new Image();
    //         img.onload = () => {
    //           resolve({ width: img.width, height: img.height });
    //         };
    //         img.onerror = reject;
    //         img.src = event.target.result;
    //       };
    //       reader.onerror = reject;
    //       reader.readAsDataURL(file);
    //     });

    //     const { width, height } = await imageDimensions;

    //     // Enforce width == 800, height between 500 and 550 inclusive
    //     // return width <= 900 && height >= 500 && height <= 550;
    //     return width <= 900 && height >= 400;
    //   }
    // ),
  });

  const handleNewsImage = (e) => {
    const file = e.target.files[0];
    setImage(file);
    formik.setFieldValue("newsImage", file);
  };

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema,
    onSubmit: async (values) => {
      // console.log("Values=> ", values);
      let formData = new FormData();
      formData.append("topic", values.topic);
      formData.append("heading", values.heading);
      formData.append("description", values.description);
      if (values.newsImage) {
        formData.append("newsImage", values.newsImage);
      } else if (values.importedImageUrl) {
        formData.append("importedImageUrl", values.importedImageUrl);
      }
      formData.append("content", contentData);
      setDisabledSubmit(true);
      try {
        let res = await axios.post(`admin-website/create-news`, formData);
        // console.log(res);
        navigate("/blogs", {
          state: { message: res.data.data.message },
        });
        toast(res.data.message, {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          type: "success",
        });
      } catch (errors) {
        const responseData = errors.response?.data;
        if (responseData?.error) {
          toast(responseData.error.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        } else {
          toast(responseData?.message || "Could not save the blog.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            type: "error",
          });
        }

        setDisabledSubmit(false);
      }
    },
  });

  const importFromSubstack = async () => {
    const url = substackUrl.trim();
    if (!url) {
      toast("Enter a Substack article URL first.", { type: "error" });
      return;
    }

    setImportingSubstack(true);
    try {
      const response = await axios.post("admin-website/fetch-substack", {
        url,
      });
      const article = response.data?.data || response.data;
      const title = String(article.title || "").trim();
      const description = String(article.description || "").trim();
      const body = String(article.body || "").trim();
      if (!title || !body) {
        throw new Error("The article response did not include usable content.");
      }

      const nextImageUrl = String(article.imageUrl || "").trim();
      await formik.setValues(
        {
          ...formik.values,
          topic: "Substack",
          heading: title,
          description,
          newsImage: null,
          importedImageUrl: nextImageUrl,
        },
        false
      );
      formik.setTouched({}, false);
      formik.setErrors({});
      setContentData(String(article.body || "").trim());
      setImportDetails({
        author: article.author || "",
        publishDate: article.publishDate || "",
      });
      setImage(null);
      setImportedImageUrl(nextImageUrl);

      toast(
        article.warning ||
          "Article imported. Review and edit the fields below before saving.",
        { type: article.warning ? "warning" : "success" }
      );
    } catch (error) {
      const responseMessage = error.response?.data?.message;
      toast(
        responseMessage ||
          error.message ||
          "Could not fetch article. Please check the URL and try again.",
        { type: "error" }
      );
    } finally {
      setImportingSubstack(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Add News</title>
      </Helmet>
      <LayoutPage>
        <div className="row">
          <div className="col-12">
            <div className="card my-4">
              <div className="card-header p-0 position-relative mt-n4 mx-3 z-index-2">
                <div
                  style={{
                    backgroundColor: "#46456e",
                  }}
                  className=" shadow-primary border-radius-lg pt-4 pb-3"
                >
                  <div className="d-flex ps-3 align-item-center">
                    <i
                      style={{ color: "#fff", cursor: "pointer" }}
                      className="fa fa-arrow-left fs-4"
                      onClick={() => {
                        navigate(-1);
                      }}
                    ></i>
                    <h6 className="text-white text-capitalize ps-4 ">
                      Add Blogs
                    </h6>
                  </div>
                </div>
              </div>
              <div className="card-body px-0 pb-2">
                <div className="p-4">
                  <form onSubmit={formik.handleSubmit}>
                    <div
                      className="mb-4 p-3"
                      style={{
                        border: "1px solid #d9d9e2",
                        borderRadius: "8px",
                        backgroundColor: "#f8f8fb",
                      }}
                    >
                      <label className="fs-5 mb-2" htmlFor="substackUrl">
                        Import from Substack
                      </label>
                      <div className="d-flex flex-wrap gap-2">
                        <input
                          id="substackUrl"
                          type="url"
                          className="form-control fs-6"
                          style={{ flex: "1 1 420px" }}
                          placeholder="https://algosports.substack.com/p/article"
                          value={substackUrl}
                          onChange={(event) =>
                            setSubstackUrl(event.target.value)
                          }
                        />
                        <button
                          type="button"
                          className="btn mb-0"
                          disabled={importingSubstack}
                          onClick={importFromSubstack}
                          style={{
                            minWidth: "120px",
                            backgroundColor: "#46456e",
                            color: "#fff",
                          }}
                        >
                          {importingSubstack ? "Importing..." : "Import"}
                        </button>
                      </div>
                      <div className="text-muted mt-2">
                        Import pre-fills this form. Nothing is published until
                        you review and submit it.
                      </div>
                      {importDetails ? (
                        <div className="text-success mt-2">
                          Article imported
                          {importDetails.author
                            ? ` from ${importDetails.author}`
                            : ""}
                          {importDetails.publishDate
                            ? ` (${new Date(
                                importDetails.publishDate
                              ).toLocaleDateString()})`
                            : ""}
                          .
                        </div>
                      ) : null}
                    </div>

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Topic</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="topic"
                        name="topic"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Topic"
                        value={formik.values.topic || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {(formik.touched.topic || formik.submitCount > 0) && formik.errors.topic ? (
                      <div className="text-danger">{formik.errors.topic}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">
                        Blog Related Image
                        {/* (max 900px width and height minimum */}
                        {/* 400px ) */}
                      </label>
                      <input
                        style={{
                          width: "100%",
                          padding: "10px",
                          fontSize: "16px",
                          borderRadius: "5px",
                          outline: "none",
                          border: "1px solid #ccc",
                        }}
                        // onChange={handleFolderSelect}
                        // webkitdirectory="true"
                        // directory="true"
                        // multiple
                        type="file"
                        name="newsImage"
                        onChange={(event) => {
                          const file = event.target.files[0] || null;
                          setImportedImageUrl("");
                          setImage(file);
                          formik.setFieldValue("importedImageUrl", "", false);
                          formik.setFieldValue(
                            "newsImage",
                            file
                          );
                          formik.setFieldTouched("newsImage", true, false);
                        }}
                        // onChange={handleNewsImage}
                      />
                    </div>
                    {(formik.touched.newsImage || formik.submitCount > 0) && formik.errors.newsImage ? (
                      <div className="text-danger">
                        {formik.errors.newsImage}
                      </div>
                    ) : null}
                    <ThumbnailPreview
                      file={image}
                      src={importedImageUrl}
                      alt="Imported Substack article thumbnail preview"
                    />
                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Heading</label>

                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="heading"
                        name="heading"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Heading"
                        value={formik.values.heading || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {(formik.touched.heading || formik.submitCount > 0) && formik.errors.heading ? (
                      <div className="text-danger">{formik.errors.heading}</div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Description</label>
                      <input
                        style={{ width: "100%" }}
                        type="text"
                        id="description"
                        name="description"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Description "
                        value={formik.values.description || ""}
                        onChange={formik.handleChange}
                      />
                    </div>
                    {(formik.touched.description || formik.submitCount > 0) && formik.errors.description ? (
                      <div className="text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}

                    <div className="input-group input-group-outline mb-3">
                      <label className="fs-5">Blog Content</label>
                      {/* <input
                        style={{ width: "100%" }}
                        type="text"
                        id="sportName"
                        name="sportName"
                        className="form-control fs-6"
                        autoComplete="off"
                        placeholder="Sport Name "
                        value={formik.values.sportName || ""}
                        onChange={formik.handleChange}
                      /> */}

                      {/* <Container>
                        <div
                        className="main"
                        // style={{ border: "2px solid black" }}
                      > */}
                      <CKEditor
                        editor={ClassicEditor}
                        data={contentData}
                        // onReady={editor => {
                        //     console.log('Editor is ready to use!', editor);
                        // }}
                        config={{
                          toolbar: [
                            "undo",
                            "redo",
                            "|",
                            "heading",
                            "|",
                            "bold",
                            "italic",
                            "|",
                            "link",
                            "bulletedList",
                            "numberedList",
                          ],
                        }}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          // console.log("Content", data);
                          setContentData(data.trim());
                        }}
                        //   onChange={formik.handleChange}
                        // onBlur={(event, editor) => {
                        //     console.log('Blur.', editor);
                        // }}
                        // onFocus={(event, editor) => {
                        //     console.log('Focus.', editor); `
                        // }}
                      />
                      {/* </div>
                      </Container> */}
                    </div>
                    {formik.errors.content ? (
                      <div className="text-danger">{formik.errors.content}</div>
                    ) : null}

                    <div className="text-center d-flex justify-content-center gap-4">
                      <button
                        type="submit"
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        {disabledSubmit ? (
                          <div>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            <span className="sr-only"></span> Submitting
                          </div>
                        ) : (
                          "Submit"
                        )}
                      </button>
                      <button
                        type="button"
                        onClick={() => navigate(-1)}
                        className="btn btn-lg  btn-lg w-20 mt-4 mb-0"
                        disabled={disabledSubmit}
                        style={{
                          backgroundColor: "#46456e",
                          color: "#fff",
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LayoutPage>
    </>
  );
}

export default AddNews;

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  height: fit-content;
  background: #fff;
  margin: 0;
  padding: 10px 5px;
  box-sizing: border-box;
  border: 2px solid black;

  .main {
    width: 100%;
    margin-bottom: 0;
    background: yellow;
  }
`;
